import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-primary-500 text-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-9 h-9 rounded-full bg-background-50 flex items-center justify-center">
                <span className="text-primary-500 font-heading text-lg font-bold">K</span>
              </div>
              <span className="font-heading text-2xl font-semibold text-background-50">
                Kakobuy Finds
              </span>
            </div>
            <p className="text-background-50/80 text-sm leading-relaxed mb-6 max-w-sm">
              Your curated destination for the best Kakobuy Spreadsheet finds. Discover trending products, shopping guides, and organized product lists updated daily.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 rounded-full border border-background-50/30 flex items-center justify-center hover:border-background-50/60 transition-colors cursor-pointer"
              >
                <i className="ri-global-line text-background-50 text-sm"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 rounded-full border border-background-50/30 flex items-center justify-center hover:border-background-50/60 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-background-50 text-sm"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 rounded-full border border-background-50/30 flex items-center justify-center hover:border-background-50/60 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-background-50 text-sm"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 rounded-full border border-background-50/30 flex items-center justify-center hover:border-background-50/60 transition-colors cursor-pointer"
              >
                <i className="ri-pinterest-line text-background-50 text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <p className="font-label text-xs uppercase tracking-widest text-background-50/60 mb-6">
              Platform Guides
            </p>
            <div className="flex flex-col gap-3">
              <a
                href="/"
                className="text-background-50/80 text-sm hover:text-background-50 transition-colors cursor-pointer"
              >
                Home
              </a>
              <a
                href="/article/kakobuy-spreadsheet-guide"
                className="text-background-50/80 text-sm hover:text-background-50 transition-colors cursor-pointer"
              >
                Kakobuy Spreadsheet Guide
              </a>
              <a
                href="/article/cssbuy-spreadsheet-guide"
                className="text-background-50/80 text-sm hover:text-background-50 transition-colors cursor-pointer"
              >
                CSSBuy Spreadsheet Guide
              </a>
              <a
                href="/article/superbuy-spreadsheet-guide"
                className="text-background-50/80 text-sm hover:text-background-50 transition-colors cursor-pointer"
              >
                Superbuy Spreadsheet Guide
              </a>
              <a
                href="/article/oopbuy-spreadsheet-guide"
                className="text-background-50/80 text-sm hover:text-background-50 transition-colors cursor-pointer"
              >
                Oopbuy Spreadsheet Guide
              </a>
            </div>
          </div>

          <div>
            <p className="font-label text-xs uppercase tracking-widest text-background-50/60 mb-6">
              Quick Links
            </p>
            <div className="flex flex-col gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-background-50/80 text-sm hover:text-background-50 transition-colors cursor-pointer"
              >
                Kakobuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-background-50/80 text-sm hover:text-background-50 transition-colors cursor-pointer"
              >
                Buy It Now
              </a>
              <a
                href="/"
                className="text-background-50/80 text-sm hover:text-background-50 transition-colors cursor-pointer"
              >
                Privacy Policy
              </a>
              <a
                href="/"
                className="text-background-50/80 text-sm hover:text-background-50 transition-colors cursor-pointer"
              >
                Terms of Service
              </a>
            </div>
          </div>

          <div>
            <p className="font-label text-xs uppercase tracking-widest text-background-50/60 mb-6">
              Categories
            </p>
            <div className="grid grid-cols-2 gap-x-6 gap-y-3">
              {categories.slice(0, 10).map((cat) => (
                <a
                  key={cat.slug}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-background-50/80 text-sm hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/15 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-50/50 text-xs">
            &copy; {new Date().getFullYear()} Kakobuy Finds. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="/"
              className="text-background-50/50 text-xs hover:text-background-50/80 transition-colors cursor-pointer"
            >
              Privacy Policy
            </a>
            <a
              href="/"
              className="text-background-50/50 text-xs hover:text-background-50/80 transition-colors cursor-pointer"
            >
              Terms of Service
            </a>
            <a
              href="/"
              className="text-background-50/50 text-xs hover:text-background-50/80 transition-colors cursor-pointer"
            >
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}